import React, { useEffect, useState } from "react";
import axios from "axios";
import { Assessment, People } from "@mui/icons-material";
import StoreMallDirectoryRoundedIcon from "@mui/icons-material/StoreMallDirectoryRounded";
import AssignmentTurnedInRoundedIcon from "@mui/icons-material/AssignmentTurnedInRounded";
import LaptopMacIcon from "@mui/icons-material/LaptopMac";
import { API_BASE_URL } from "../../Config/config";

import AssetTypePieChart from "../assetchart";
import AssetMonthlyBarChart from "../assetmonthlybarchart";
import "../../styles/dashboard.css";

const Dashboard = ({ setActiveTab }) => {
  const [totalAssets, setTotalAssets] = useState(0);
  const [inventoryCount, setInventoryCount] = useState(0);
  const [trackedAssetCount, setTrackedAssetCount] = useState(0);
  const [staffCount, setStaffCount] = useState(0);
  const [usersCount, setUsersCount] = useState(0);
  const [assetTypeData, setAssetTypeData] = useState({
    fixed: 0,
    current: 0,
    intangible: 0,
    inventory: 0,
  });
  const [assetsData, setAssetsData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        //  dashboard tiles data
        const totalResponse = await axios.get(`${API_BASE_URL}/assets/all`);

        setTotalAssets(totalResponse.data.assets || 0);
        setInventoryCount(totalResponse.data.inventories || 0);
        setTrackedAssetCount(totalResponse.data.trackings || 0);
        setStaffCount(totalResponse.data.staffs || 0);
        setUsersCount(totalResponse.data.users || 0);

        //  chart data
        const chartResponse = await axios.get(`${API_BASE_URL}/assets`);
        const assets = chartResponse.data.assets || [];

        // Store assets data for the bar chart
        setAssetsData(assets);

        // chart data - count asset types
        const assetTypeCounts = {
          fixed: 0,
          current: 0,
          intangible: 0,
          inventory: 0,
        };

        assets.forEach((asset) => {
          const assetType = asset.asset_type?.toLowerCase();
          if (assetTypeCounts.hasOwnProperty(assetType)) {
            assetTypeCounts[assetType]++;
          }
        });

        setAssetTypeData(assetTypeCounts);
      } catch (error) {
        //console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const dashboardItems = [
    {
      title: "Total Assets",
      value: totalAssets,
      icon: <Assessment className="display-icon" />,
      tab: "Asset Register",
    },
    {
      title: "Inventory",
      value: inventoryCount,
      icon: <StoreMallDirectoryRoundedIcon className="display-icon" />,
      tab: "Inventory",
    },
    {
      title: "Tracked Assets",
      value: trackedAssetCount,
      icon: <AssignmentTurnedInRoundedIcon className="display-icon" />,
      tab: "Asset Tracking",
    },
    {
      title: "Staff",
      value: staffCount,
      icon: <People className="display-icon" />,
      tab: "Staff",
    },
    {
      title: "Users",
      value: usersCount,
      icon: <LaptopMacIcon className="display-icon" />,
      tab: "Users",
    },
  ];

  const handleTileClick = (tab) => {
    if (setActiveTab) {
      setActiveTab(tab);
    }
  };

  return (
    <div className="dashboard-container">
      <h1
        style={{
          fontSize: "30px",
          marginBottom: "20px",
          fontWeight: "bold",
          color: "#000000",
        }}
      >
        Dashboard
      </h1>

      <div className="dashboard-display-grid">
        {dashboardItems.map((item, index) => (
          <div
            key={index}
            className="display-block"
            onClick={() => handleTileClick(item.tab)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                handleTileClick(item.tab);
              }
            }}
          >
            {item.icon}
            <div className="display-title">{item.title}</div>
            <div className="display-value">{item.value}</div>
          </div>
        ))}
      </div>

      {/* Charts container  */}
      <div className="charts-container hidden md:flex">
        <AssetTypePieChart assetTypeData={assetTypeData} />
        <AssetMonthlyBarChart assets={assetsData} />
      </div>
    </div>
  );
};

export default Dashboard;
